module.exports = __webpack_public_path__ + "static/img/tab-banner1.8975e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/tab-banner1.png
// module id = UdxU
// module chunks = 1